// @flow

import React from 'react';
import styled from 'styled-components';
import PdbImage from '../../pdbImage';
import type { Theme } from '../../../types';

type Props = {|
  src: string,
  alt?: string,
  className: string,
|};

const ImageContainer = styled<any, Theme>('div')`
  min-height: 7rem;
`;

const Image = ({ src, alt, className }: Props) => (
  <ImageContainer className={className}>
    <PdbImage url={src} alt={alt} />
  </ImageContainer>
);

Image.defaultProps = {
  alt: '',
};

export default styled<typeof Image, Theme>(Image)`
  text-align: center;
`;
